import { useRef, useState, useEffect, useContext } from "react";
import Select from "react-select";
import { customSelSearch } from "../utils/configs";
import {ThemeContext} from "../contexts/themeContext";

const CustomSelect = (props) => {
  const {
    options,
    placeHolder,
    onChange,
    value,
    onMenuClose,
    onMenuOpen,
    menuPosition,
    menuPortalTarget,
    width,
    isDisabled,
    isClearable,
    isSearchable,
    autoWidth,
    rightMargin
  } = props;

  const selectRef = useRef(null);
  const [widthAuto, setWidthAuto] = useState("100%");
const marginStyle = rightMargin ? { marginRight: rightMargin } : {};
const {themedColor} = useContext(ThemeContext);

  useEffect(() => {
    if (autoWidth) {
      const handleResize = () => {
        if (selectRef.current) {
          setWidthAuto(selectRef.current.offsetWidth);
        }
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [autoWidth]);

  return (
    <div ref={selectRef} className="selectWrapper" style={{ width: "100%", ...marginStyle }}>
      <Select
        {...(value !== undefined && { value })}
        defaultValue={value || null}
        onMenuOpen={onMenuOpen || null}
        onMenuClose={onMenuClose || null}
        isDisabled={isDisabled || false}
        options={options}
        menuShouldBlockScroll={false}             
        menuPosition={menuPosition ||"absolute" } 
        menuPortalTarget={menuPortalTarget || document.body}             
        menuShouldScrollIntoView={false} 
        styles={{
        ...customSelSearch(themedColor),
        control: (base) => ({
        ...base,
        backgroundColor: themedColor.background,
        width: autoWidth ? widthAuto : width || "13rem",
        boxShadow: "none",
        marginRight: rightMargin || "0px", 
        }),
        option: (base, state) => ({
        ...base,
        fontSize: "13px",
        fontWeight: 400,
        padding: "8px 12px",
        backgroundColor: state.isFocused
        ? themedColor.hover
        : themedColor.background,
        color: "#E6EEF4",
        cursor: "pointer",
        }),

        menu: (base) => ({
        ...base,
         width: "100%",
         minWidth: "100%",
         backgroundColor: themedColor.background,
        zIndex: 5,
        }),

        menuList: (base) => ({
        ...base,
        padding: 0,
        scrollbarWidth: "thin",
        scrollbarColor: "#1a2948 #0f172a",
        backgroundColor: themedColor.background,
        "&::-webkit-scrollbar": {
        width: "8px",
        },
        "&::-webkit-scrollbar-track": {
        background: themedColor.background,
        },
        "&::-webkit-scrollbar-thumb": {
        backgroundColor: themedColor.hover,
        borderRadius: "6px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#2B4B66",
        },
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999, left: base.left }),
        }}
        placeholder={placeHolder}
        onChange={onChange}
        isClearable={isClearable ?? true}
        isSearchable={isSearchable ?? true}
      />
    </div>
  );
};

export default CustomSelect;
